import React, { Children, FC, ReactElement } from 'react';

const gridStyle = {
  display: 'flex',
  flexFlow: 'row wrap',
};

interface GridProps {
  children: ReactElement | ReactElement[];
  display: boolean;
}

const Grid: FC<GridProps> = (gridProps: GridProps) => {
  const { children, display } = gridProps;

  return display ? (
    <div style={gridStyle}>
      {React.Children.map(children, (child) => child)}
    </div>
  ) : null;
};

export default Grid;
